var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 71,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.775 14.655H1.6v54.462h76.175V14.655Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.819 24.022h17.605v17.605M69.424 24.022 46.289 44.786",
    stroke: "#FED000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.885 14.204V9.69M48.885 5.514V1h4.514",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.587 1h37.805",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "8.66 10.82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.486 1H114v4.514",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114 17.928v16.137",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "8.8 11"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114 40.272v4.514h-4.514",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.78 44.786H87.141",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "6.88 8.6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.288 44.786h-4.514",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag-icon.fd4f20ff.svg";
export { ForwardRef as ReactComponent };